// app/lib/seo.ts — SeoLocals (van utils/seo-helpers.js) → React Router meta-descriptors.
// Reproduceert views_public/partials/seo-head.ejs 1-op-1: title, description,
// keywords, robots, canonical, volledige Open Graph, Twitter card en JSON-LD.

import type { SeoLocals } from '#shared/types/article';

export type { SeoLocals };

type MetaDescriptor = Record<string, unknown>;

export function seoMeta(seo: SeoLocals | null | undefined): MetaDescriptor[] {
  if (!seo) return [{ title: 'LEZA Kennisbank' }];
  const out: MetaDescriptor[] = [
    { title: seo.title },
    { name: 'description', content: seo.description },
  ];
  if (seo.keywords) out.push({ name: 'keywords', content: seo.keywords });
  out.push({ name: 'robots', content: seo.noindex ? 'noindex, nofollow' : 'index, follow' });
  if (seo.canonical) out.push({ tagName: 'link', rel: 'canonical', href: seo.canonical });

  // Open Graph
  out.push(
    { property: 'og:type', content: seo.og_type },
    { property: 'og:title', content: seo.og_title },
    { property: 'og:description', content: seo.og_description },
    { property: 'og:url', content: seo.og_url },
    { property: 'og:site_name', content: seo.siteName },
    { property: 'og:locale', content: 'nl_NL' },
  );
  if (seo.og_image) out.push({ property: 'og:image', content: seo.og_image });
  if (seo.og_type === 'article') {
    if (seo.datePublished) out.push({ property: 'article:published_time', content: seo.datePublished });
    if (seo.dateModified) out.push({ property: 'article:modified_time', content: seo.dateModified });
  }

  // Twitter
  out.push(
    { name: 'twitter:card', content: 'summary_large_image' },
    { name: 'twitter:title', content: seo.og_title },
    { name: 'twitter:description', content: seo.og_description },
  );
  if (seo.og_image) out.push({ name: 'twitter:image', content: seo.og_image });

  // JSON-LD (Article + Breadcrumb) — RR7 rendert {'script:ld+json'} als <script type="application/ld+json">
  for (const ld of [seo.jsonLd, seo.breadcrumbJsonLd]) {
    if (ld) {
      try { out.push({ 'script:ld+json': JSON.parse(ld) }); } catch { /* al object of ongeldig */ }
    }
  }
  return out;
}

export function seoLinks(seo: SeoLocals | null | undefined) {
  return seo?.canonical ? [{ rel: 'canonical', href: seo.canonical }] : [];
}
